// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PROFILE_TABS_POSTS = "Pr\u00edspevky";
export const PROFILE_TABS_PRODUCTS = "Pou\u017e\u00edvam";
